import React from 'react'
import { Alert } from '@material-ui/lab'

const CustomAlert = ({ severity, message }) => (

    message && <Alert style={{ margin: '30px' }} severity={severity}>{message}</Alert>
)

CustomAlert.defaultProps = {
    severity: "warning",
    message: "Ocorreu um erro. Por favor, tente novamente."
}

export default CustomAlert